import MarkdownRenderer from '../Markdown/MarkdownRenderer';

const CookiesContentFromMarkdown = () => {

  return (
    <div>
      <MarkdownRenderer file="/content/cookie-policy.md" />
    </div>
  );
};

export default CookiesContentFromMarkdown;
